import React from 'react'
import { Button, Input } from 'reactstrap'
import { sortCaret, IconeDelete, IconeEditar } from '../../../comum/components/Icones'
import { observable } from 'mobx'
import DirecionamentoTeconService from '../../../../services/DirecionamentoTeconService'
import { situacaoFormatter, formatFieldDate, formatContainers } from '../../../../utils/formatar';
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';

export default class DirecionamentoTeconStore {

    @observable operacao;
    @observable status;
    @observable ce;
    @observable container;
    @observable cnpj;
    @observable cliente;

    @observable listaOperacoes;
    @observable listaStatus;

    @observable itens;
    @observable hasMore;
    @observable listaSelecionados;
    @observable listaAdicoes;
    @observable filtrado;
    
    @observable loadingOperacoes;
    @observable loadingDirec;
    @observable loadingSalvar;
    @observable tableMessage;
    @observable mensagem;
    @observable adicionando;
    @observable editando;
    @observable elementoEmEdicao;
    @observable navioAssociado;
    
    @observable modalAdicionarAnexo;
    @observable modalInativar;
    @observable modalAdicionar;
    @observable modalImportar;
    @observable listaDirecionamentos;

    
    constructor() {

        //Filtros

        this.operacao = ""
        this.status = ""
        this.ce = ""
        this.container = ""
        this.cnpj = ""
        this.cliente = ""

        //Fim Filtros
        
        this.listaDirecionamentos = []
        this.listaSelecionados = []
        this.listaOperacoes = []
        this.listaAdicoes = []
        this.listaStatus = []
        this.enviados = []
        this.itens = []

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"

        this.idAdd = 0
        this.turn = 0
        this.toShow = 20

        this.colunas = this.todasColunas

        this.modalAdicionarAnexo = false
        this.loadingOperacoes = false
        this.modalAdicionar = false
        this.navioAssociado = false
        this.modalImportar = false
        this.modalInativar = false
        this.loadingSalvar = false
        this.loadingDirec = false
        this.adicionando = false
        this.filtrado = false
        this.editando = false
        this.hasMore = false


        this.elementoEmEdicao = null

        this.tableMessage = buscaFiltrarVazio
        this.mensagem = ""
        
        this.outrosDados = [
            { titulo : "Arquivo Anexo", field: ["NomeArquivo"], id:"F1", hidden: false , download:true},
            { titulo : "Criado por", field: ["NomeImport", "DtImport"], formatacao: formatFieldDate ,id:"F2", hidden: false},
            { titulo : "Inativado por", field: ["NomeCancel", "DtCancel"], formatacao: formatFieldDate ,id:"F3", hidden: false},
            { titulo : "Container", field: ["Container"], formatacao: formatContainers, id:"F5", hidden: false}
        ];

        this.service = new DirecionamentoTeconService()

        this.listarOperacoes()
        this.listarStatus()

    }

    // Listagem de dados
    // Direcionamentos - Tabela contendo os dados
    listarDirecionamentos = () => {
        this.tableMessage = ""
        this.filtrado = true
        this.loadingDirec = true
        this.service.TeconConsultar(
                "",
                this.operacao ? this.operacao.value : "",
                this.status ? this.status.value : "",
                this.ce,
                this.container,
                this.cnpj,
                this.cliente,
                this.navioAssociado ? "S" : "N"
                ).then(response => {
            if(response && response.data){
                this.listaDirecionamentos = response.data
                this.listaDirecionamentos.forEach(direc => {
                    direc.selecionado = false
                })
                
                if(this.listaDirecionamentos.length === 0) {
                    this.tableMessage = buscaSemResultado
                }

                this.loadFirstTurn()

            }
        }).catch(err => console.log(err)
        ).finally(() => {this.loadingDirec = false})
    }

    loadFirstTurn = () => {
       
        this.itens = this.listaDirecionamentos.slice(0, this.toShow)
        this.turn = 1
        this.hasMore = this.itens.length < this.listaDirecionamentos.length
    }

    loadNextTurn = () => {
        this.itens = []
        this.itens = this.listaDirecionamentos.slice(0, (this.turn+1)*this.toShow)
        this.turn = this.turn+1

        this.hasMore = this.itens.length < this.listaDirecionamentos.length
    }

    // Operações - Filtro de Operações
    listarOperacoes = () => {
        this.loadingOperacoes = true
        this.service.TeconOperacoes().then(response => {
            if(response && response.data){
                this.listaOperacoes = response.data.map(resp => ({label:resp.NavioViagem, value: resp.CarrierVisitId}))
            }
        }).catch(err => console.log(err)
        ).finally(() => this.loadingOperacoes = false)
    }

    // Status - Filtro de Status
    listarStatus = () => {
        this.service.Status().then(response => {
            if(response && response.data){
                this.listaStatus = response.data.map(resp => ({label: resp, value: resp}))
            }
        }).catch(err => console.log(err))
    }
    
    // Clientes - Filtro de Clientes
    listarClientes = (value) => {
        this.cliente = value
    }
    // FIM da Listagem de dados
    
    // Métodos set para os filtros  
    setOperacao = (value) => {
        this.operacao = value
    }

    setStatus = (value) => {
        this.status = value
    }

    setCe = (value) => {
        this.ce = value
    }

    setContainer = (value) => {
        this.container = value
    }

    setCnpj = (value) => {
        this.cnpj = value
    }

    setCliente = (value) => {
        this.cliente = value
    }

    setFiltroNavioAssociado = (value) => {
        this.navioAssociado = value
    }

    // Fim dos métodos set


    // Modal
    abrirModalImportar = () => {
        this.modalImportar = true 
    }

    abrirModalAdicionar = () => {
        this.modalAdicionar = true
    }
    
    fecharModalImportar = () => {
        this.modalImportar = false
    }
    
    fecharModalAdicionar = () => {
        this.modalAdicionar = false
    }

    abrirModalInativar = () => {
        this.modalInativar = true;
    }

    abrirAdicionarAnexo = (row) => {
        this.elementoEmEdicao = row
        this.modalAdicionarAnexo = true
    }
    
    fecharAdicionarAnexo = () => {
        this.elementoEmEdicao = null
        this.modalAdicionarAnexo = false
    }

    confirmarInativar = () => {
        const listaInativar = [];
        
        this.listaSelecionados.map((value, index) => {
            let item = {"CeHouse": value.CeHouse, "CarrierVisitId": value.CarrierVisitId, "UsuarioImport": value.UsuarioImport} 
            listaInativar[index] = item;
        })

        this.service.TeconInativar(listaInativar).then(response => {
            if(response && response.data){
                if(response.data.Sucesso === true){
                    this.mensagem = `${listaInativar.length > 1 
                        ? "Direcionamentos inativados" 
                        : "Direcionamento inativado"} com sucesso`
                    }else{
                        //TODO padronizar mensagens
                        if(response.data.MensagemErro) {
                            this.mensagem = response.data.MensagemErro
                        } else {
                            this.mensagem = `Não foi possível inativar ${listaInativar.length > 1 
                                ? "os direcionamentos" 
                                : "o direcionamento"}`
                        }
                }
            }
            // mensagem de sucesso e erro
        }).catch(err => console.log(err) //mensagem de erro
        ).finally(() => {
            this.modalInativar = false
            this.listarDirecionamentos()
        })
    };

    cancelaInativar = () => {
        this.modalInativar = false;
    };


    downloadArquivoAnexo = (teconId, nomeArquivo) => {
        this.service.RecintoDownloadDocumento(teconId).then((response) => {
            if(response && response.data){
                //console.log(teconId)
                //console.log(response)
                this.gerarLinkDownload(response.data, nomeArquivo)
            }
        }).catch(err => console.error(err))
    }

    gerarLinkDownload = (dadosArquivo, anexo) => {
        let typeOfFile = "octet/stream";

        if (anexo.includes("pdf")) 
            typeOfFile = "application/pdf";
        if (anexo.includes("txt")) 
            typeOfFile = "text/plain";
        if (anexo.includes("doc"))
            typeOfFile = "application/msword";
        if (anexo.includes("gif"))
            typeOfFile = "image/gif";
        if (anexo.includes("png"))
            typeOfFile = "image/png";
        if (anexo.includes("jpg") || anexo.includes( ".jpeg"))
            typeOfFile = "image/jpeg";

        const file = new File([dadosArquivo], anexo, { type: typeOfFile });        
        const url = window.URL.createObjectURL(file)
        this.download.href = url
        //this.download.download = anexo
        this.download.click()
        window.URL.revokeObjectURL(url)
    }

    fecharModalMensagem = () => {
        this.mensagem = ""
    }

    // Fim Modal


    // Selecionar

    selecionar = (direc, isSelect) => {
        direc.selecionado = isSelect
        this.listaSelecionados = this.itens.filter(i => i.selecionado === true);
    }


    selecionarTodos = (checked) => {
        this.itens.forEach(item => {
            item.selecionado = checked;
        });
    
        this.listaSelecionados = this.itens.filter(i => i.selecionado);
    }

    // Fim Selecionar

    anexarArquivo = (event) => {
        this.elementoEmEdicao.Anexo = null //considerando sempre que só existirá 1 anexo
        if(event.target.files){
            this.elementoEmEdicao.Anexo = { file: event.target.files[0], name: event.target.files[0].name.replace(/[^a-zA-Z0-9\.]/g, "") }
        }
    }

    removerAnexo = () => {
        this.elementoEmEdicao.Anexo = null
    }

    // Adicionar

    adicionarListaAdicoes = (ceHouse,emails,codRef,listaAnexos) => {
        this.listaAdicoes.push({
            IdAdd: this.idAdd,
            CeHouse:ceHouse,
            Email: emails,
            CodRef: codRef,
            Anexo: listaAnexos && listaAnexos[0] // Considerando somente 1 anexo, caso exista uma lista de anexos isso precisa ser modificado
        })

        this.idAdd += 1
    }

    salvarNovosDirecionamentos = () => {
        this.loadingSalvar = true
        Promise.all(
            this.listaAdicoes.map(adicao => {
                let arqv = new FormData()
                if(adicao.Anexo){
                    arqv.append('file', adicao.Anexo.file);
                }else{
                    arqv = ""
                }
                if(!(this.enviados.includes(adicao.IdAdd))) {
                    return this.service.TeconInclusao(adicao.CeHouse, adicao.Email, adicao.CodRef, arqv).then(response =>{
                        if(response === "Verifique sua conexão" || (response && response.data && response.data.Sucesso === false)) {
                            this.mensagem = response.data ? response.data.MensagemErro :"Houve um erro na inclusão"
                            return Promise.reject()
                        }else{
                            this.enviados.push(adicao.IdAdd)
                            return Promise.resolve()
                        }
                    })
                }
            })
        ).then(() => {
            this.listaAdicoes = []
            this.enviados = []
            this.adicionando = false
            this.mensagem = "Inclusão realizada com sucesso"
            //mensagem de sucesso
        },() => {
            //this.mensagem = "Houve um erro na inclusão"
            //mensagem de erro
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            this.loadingSalvar = false
            if(this.operacao || this.status || this.ce || this.container || this.cnpj || this.cliente){
                this.listarDirecionamentos()
            }
        })
        
    }

    cancelarAdicao = () => {
        this.listaAdicoes = []
        this.enviados = []
        this.adicionando = false
    }

    removerAdicaoLista = (row) => {
        const data = this.listaAdicoes.find(add => add.IdAdd === row.IdAdd)
        const index = this.listaAdicoes.indexOf(data)
        this.listaAdicoes.splice(index, 1)
    }

    editarElementoListaAdicao = (row) => {
        this.elementoEmEdicao = row
        this.editando = true
        this.modalAdicionar = true
    }

    alterarDadosEdicao = ( ceHouse, emails, codRef, listaAnexos) => {
        this.listaAdicoes = this.listaAdicoes.map(add => {
            let dado = {}
            if(add.IdAdd === this.elementoEmEdicao.IdAdd){
                dado.IdAdd = add.IdAdd
                dado.CeHouse = ceHouse
                dado.Email = emails
                dado.CodRef = codRef
                dado.Anexo = listaAnexos && listaAnexos[0]
            }else{
                dado = add
            }
            return dado
        })
    }

    fecharEdicao = () => {
        this.elementoEmEdicao = null
        this.editando = false
        this.modalAdicionar = false
    }

    mostrarTabelaAdicionar = () => {
        this.adicionando = true
    }

    fecharTabelaAdicionar = () => {
        this.adicionando = false
    }

    // Fim Adicionar

    // Botões

    renderAcao = (row) => {
        return (
            <Button className="btn-com-bordas-cinza px-2" onClick={() => this.editarElementoListaAdicao(row)}>
                Editar
            </Button>
        )
    }

    renderExcluir = (row) => {
        return(
            <IconeDelete tamanho="2x" onClick={() => this.removerAdicaoLista(row)} />
        )
    }

    renderAnexoBotao = (cell,row) => {
        if(!row.Anexo) {
            return (
                <Button className="btn-com-bordas-primary px-2" onClick={() => this.abrirAdicionarAnexo(row)}>Anexar</Button>
            )
        } else {
            return <div onClick={() => this.abrirAdicionarAnexo(row)}>
                { row.Anexo.name }
                <IconeEditar tamanho="sm" className="ml-2" />
                </div>
        }
    }

    // Fim Botões


    todasColunas = [
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CE",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CNPJ",
            dataField: "Cnpj",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Razão social",
            dataField: "RazaoSocial",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Booking",
            dataField: "BookingSaida",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Situação",
            dataField: "Status",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
    ]

    colunasAdicionar = [
        {
            text: "CE House",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Código de referência",
            dataField: "CodRef",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Emails",
            dataField: "Email",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Anexo",
            dataField: "Anexo.name", //Dá um jeito nisso depois
            sort: true,
            formatter: (cell, row) => this.renderAnexoBotao(cell, row),
            typeButton: "Editar",
            buttonOnclick: this.abrirAdicionarAnexo,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Ação",
            dataField: "acao",
            sort: true,
            headerAlign: () => "center",
            align: 'center',
            sortCaret: sortCaret,
            typeButton: "Editar",
            buttonOnclick: this.editarElementoListaAdicao,
            formatter: (cell, row) => this.renderAcao(row)
            // Adicionar o formater para os botões
        },
        {
            text: "Excluir",
            dataField: "excluir",
            sort: true,
            headerAlign: () => "center",
            align: 'center',
            sortCaret: sortCaret,
            typeButton: "Excluir",
            buttonOnclick: this.removerAdicaoLista,
            formatter: (cell, row) => this.renderExcluir(row)
            // Adicionar o formater para os botões
        },
    ]

    colunasExportar = [
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CE",
            dataField: "CeHouse",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "CNPJ",
            dataField: "Cnpj",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Booking",
            dataField: "BookingSaida",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Razão social",
            dataField: "RazaoSocial",
            sort: true,
            headerAlign: () => "left",
            sortCaret: sortCaret,
        },
        {
            text: "Situação",
            dataField: "Status",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Cliente",
            dataField: "Status",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Criado por",
            dataField: "NomeImport",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Data Criação",
            dataField: "DtImport",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Inativado por",
            dataField: "NomeCancel",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Data Inativação",
            dataField: "DtCancel",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        },
        {
            text: "Containers",
            dataField: "Container",
            sort: true,
            align: "center",
            formatter: situacaoFormatter,
            sortCaret: sortCaret,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/stores/DirecionamentoTeconStore.js